import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { IoQrCodeOutline } from "react-icons/io5";

// Assets
import { FaLink } from "react-icons/fa6";

// Estilos
import styles from './QRCode.module.css';

function QRCodeActions({ link, fileName = "qrcode", onCopySuccess, onCopyError }) {
    const qrRef = useRef();

    const downloadQRCode = () => {
        const originalCanvas = qrRef.current.querySelector('canvas');
        const originalSize = originalCanvas.width;

        const margin = originalSize * 0.15; // margem 15%
        const newSize = originalSize + margin * 2;

        const canvas = document.createElement("canvas");
        canvas.width = newSize;
        canvas.height = newSize;
        const ctx = canvas.getContext("2d");

        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, newSize, newSize);

        ctx.drawImage(originalCanvas, margin, margin);

        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        a.download = `${fileName}.png`;
        a.click();
    };

    const copyLink = () => {
        navigator.clipboard.writeText(link).then(() => {
            if (onCopySuccess) onCopySuccess();
        }).catch(() => {
            if (onCopyError) onCopyError();
        });
    };

    return (
        <div className={styles.mainDiv}>
            <div style={{ display: "none" }} ref={qrRef}>
                <QRCodeCanvas value={link} size={200} />
            </div>

            <button
                onClick={copyLink}
                className={styles.qrButton}
                title="Copiar link do teste"
            >
                <FaLink />
            </button>

            <button
                onClick={downloadQRCode}
                className={styles.qrButton}
                title="Baixar QR Code do teste"
            >
                <IoQrCodeOutline />
            </button>
        </div>
    );
}

export default QRCodeActions;